export const GET_PASSES_REQUEST = 'GET_PASSES_REQUEST'
export const GET_PASSES_SUCCESS = 'GET_PASSES_SUCCESS'
export const GET_PASSES_FAIL = 'GET_PASSES_FAIL'
export const GET_PASSES_RESET = 'GET_PASSES_RESET'
